<template>
  <v-card>
    <v-tabs
      v-model="tab"
      :vertical="$vuetify.breakpoint.mdAndUp"
    >
      <v-tab>
        Info
      </v-tab>
      <v-tab>
        Subscriptions
      </v-tab>
      <v-tab>
        Bookings
      </v-tab>
      <v-tab>
        Cards
      </v-tab>
      <v-tab>
        Payments
      </v-tab>
      <v-tab>
        Invoices
      </v-tab>
      <v-tab>
        Balance
      </v-tab>
      <v-tab>
        Discount
      </v-tab>

      <v-tab-item>
        <customer-information
          :id="$route.params.id"
        />
      </v-tab-item>

      <v-tab-item>
        <customer-subscriptions
          :id="$route.params.id"
        />
      </v-tab-item>

      <v-tab-item>
        <customer-bookings
          :id="$route.params.id"
        />
      </v-tab-item>

      <v-tab-item>
        <customer-cards
          :customer-id="$route.params.id"
          :default-source="getDefaultPaymentMethod()"
        />
      </v-tab-item>

      <v-tab-item>
        <customer-payments
          :id="$route.params.id"
        />
      </v-tab-item>

      <v-tab-item>
        <customer-invoices
          :id="$route.params.id"
        />
      </v-tab-item>

      <v-tab-item>
        <customer-balance-transactions
          :id="$route.params.id"
          :balance="customer.balance"
          :currency="customer.currency"
        />
      </v-tab-item>

      <v-tab-item>
        <customer-discount
          :id="$route.params.id"
          :init-customer="customer"
        />
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>
<script>
import { mapActions } from 'vuex'
import { get } from 'lodash'
import CustomerCards from '@/components/Customer/CustomerCards'
import CustomerSubscriptions from '@/components/Customer/CustomerSubscriptions'
import CustomerPayments from '@/components/Customer/CustomerPayments'
import CustomerInvoices from '@/components/Customer/CustomerInvoices'
import CustomerBalanceTransactions from '@/components/Customer/CustomerBalanceTransactions'
import CustomerDiscount from '@/components/Customer/CustomerDiscount'
import CustomerInformation from '@/components/Customer/CustomerInformation'


import { unixToReadableDate } from "../../services/util.service"
import CustomerBookings from "./CustomerBookings"

export default {
  components: {
    CustomerBookings,
    CustomerCards,
    CustomerSubscriptions,
    CustomerPayments,
    CustomerInvoices,
    CustomerBalanceTransactions,
    CustomerDiscount,
    CustomerInformation
  },
  data() {
    return {
      isLoading: false,
      customer: {},
      tab: null
    }
  },
  async created() {
    const payload = {
      id: this.$route.params.id
    }

    this.isLoading = true
    const customer = await this.getCustomer(payload)
      .finally(() => {
        this.isLoading = false
      })

    this.customer = customer || {}
  },
  methods: {
    ...mapActions([ 'getCustomer' ]),
    getDefaultPaymentMethod() {
      return get(this.customer, 'invoice_settings.default_payment_method', '')
        || get(this.customer, 'default_source', '')
    },
    get(obj, path, defaultValue) {
      return get(obj, path, defaultValue)
    },
    onUpdate(customer) {
      this.customer = { ...customer }
    },
    formatDate(timestamp) {
      return unixToReadableDate(timestamp)
    }
  },
}
</script>
